import {useState, useEffect} from 'react';
import {Box, IconButton, Typography} from '@mui/material';

import {useDispatch, useSelector} from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';
import {t} from 'i18next';
import {RootState} from '../../../redux/store';
import AurBanner from '../../common/aur-banner/AurBanner';
import {setSearchResultError} from '../../../redux/slices/ecaAdhocSearchSlice';

interface ISearchResultErrorBannerProps {
  hasFullWidth?: boolean;
}
const SearchResultErrorBanner = (props: ISearchResultErrorBannerProps) => {
  const {hasFullWidth = false} = props;
  const searchResultError = useSelector(
    (state: RootState) => state.ecaAdhocSearch.searchResultError
  );
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  // Show banner whenever searchResultError appears
  useEffect(() => {
    if (searchResultError) {
      setOpen(true);
    }
    return () => {
      if (open) {
        dispatch(setSearchResultError(null)); // Clear error only if it was shown
      }
    };
  }, [searchResultError, open, dispatch]);

  // Function to close banner and reset Redux store
  const handleClose = () => {
    setOpen(false);
    dispatch(setSearchResultError(null));
  };

  // Function to render the dismiss button
  const renderAction = () => (
    <IconButton
      className="typo-text buttonSmall_size"
      name="dismiss"
      aria-label={t('common.close')}
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" sx={{color: '#F2F4F7'}} />
      <Typography className="typo-text label2_size dismiss">
        {t('buttons.dismiss')}
      </Typography>
    </IconButton>
  );

  if (!open || !searchResultError) return null; // Hide if closed or no status
  return (
    <Box className="error-toast">
      <AurBanner
        errorText={searchResultError ?? ''}
        errorType="warning"
        showIcon
        hasFullWidth={hasFullWidth}
        renderAction={renderAction}
      />
    </Box>
  );
};

export default SearchResultErrorBanner;
